// src/components/ErrorMessage.jsx
// Shared error alert box — replaces 6 slightly-different hand-rolled
// versions (different reds, different padding, different radius, one
// with a stray inline "⚠" and one without) with one consistent pattern.
import { T, alpha } from '../theme/theme'

export default function ErrorMessage({ children, style = {} }) {
  if (!children) return null
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: '8px',
      background: T.rdd, border: `1px solid ${alpha(T.rd, 0.25)}`,
      borderLeft: `3px solid ${T.rd}`, borderRadius: '8px',
      padding: '10px 14px', fontSize: '13px', color: T.rd,
      lineHeight: '1.5',
      ...style,
    }}>
      {children}
    </div>
  )
}
